itsoftApp.createModule("customDropMenu", function () {
    var module = this;

    var initCustomDropMenu = function () {
        var dropTriggers = document.querySelectorAll('.js-drop');
        var dropClass = 'js-drop-open';
        var isOpen;
        var target;
        var targetDoucument;

        if (dropTriggers) {

            dropTriggers.forEach((trigger) => {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();

                    isOpen = e.currentTarget.parentNode.classList.contains(dropClass);
                    target = e.currentTarget;
                    
                    if (isOpen) {
                      target.parentNode.classList.remove(dropClass);
                    } else {
                        dropTriggers.forEach((el) => {
                        el.parentNode.classList.remove(dropClass);
                      });
                      target.parentNode.classList.add(dropClass);
                    }
                });
            })
            
            document.addEventListener('click', (e) => {
                targetDoucument = e.target;
                if (!targetDoucument.closest('.js-drop-open')) {
                    dropTriggers.forEach((el) => {
                        el.parentNode.classList.remove(dropClass);
                    });
                }
            });
        }
    };

    initCustomDropMenu();

    module.callback = initCustomDropMenu;
});
